module.exports = __webpack_public_path__ + "878ca755e16e448bccf33270dd7c0e23.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/members/blaho.jpg
// module id = 1241
// module chunks = 0